import React from 'react';
import {word} from "../../word.js";
import Path from "../../assets/img/Path 286.svg";
import {Col} from "react-bootstrap";
const getHeightByStatus = (status) => {
    switch (status) {
        case "new":
            return "33%"; // Adjust as per logic
        case "process":
            return "66%";
        case "end":
            return "100%";
        default:
            return "0%";
    }
};
function TaskLine({form}) {
    return (
        <div className="recommendations-line">
            <div className="green-line">
                {/* Green Progress Indicator */}
                <div className="inside-green" style={{ height: getHeightByStatus(form?.status) }}/>

                {/* Status Indicators */}
                {["new", "process", "end"].map((status, index) => (
                    <div key={status} className={`task-rounds task-rounds${index + 1}`}>
                        <div className="tasks-date">
                                <span>
                                    {status === "new"
                                        ? word.new_created
                                        : status === "process"
                                            ? word.in_the_process
                                            : word.completed}
                                </span>
                            <img src={Path} alt="status-icon" />
                        </div>
                        <div className="rounds">
                            <div className="point"/>
                            {form?.status === status && (
                                <div className="icon-point">
                                    <span className="icon-Yes"/>
                                </div>
                            )}
                        </div>
                    </div>
                ))}
            </div>
        </div>

    );
}

export default TaskLine;